import * as React from "react";
const SvgFiRrLeaderboard = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-leaderboard_svg__a)">
      <path
        fill="#062147"
        d="M20.249 6.158a.997.997 0 0 0-1.217.719 1 1 0 0 0 .719 1.217A3 3 0 0 1 21.828 10H2.172a3 3 0 0 1 2.077-1.906.999.999 0 1 0-.498-1.936A5 5 0 0 0 0 10.999v8c0 2.758 2.243 5 5 5h14c2.757 0 5-2.242 5-5v-8a4.996 4.996 0 0 0-3.751-4.841M10 18v-2h12v2zm-2-4H2v-2h6zm2-2h12v2H10zm-8 4h6v2H2zm.184 4H8v2H5a3 3 0 0 1-2.816-2M19 22h-9v-2h11.816A3 3 0 0 1 19 22M7.003 5.986V.91c0-.358.202-.674.526-.825.3-.136.654-.114.887.052.042.03 1.363 1.787 1.363 1.787L11.05.418c.536-.54 1.356-.55 1.856-.055l1.318 1.557L15.37.343c.265-.327.662-.438 1.029-.308a.9.9 0 0 1 .604.856v5.107c0 .535-.208 1.038-.587 1.416a2 2 0 0 1-1.412.584h-.005l-6-.014a2 2 0 0 1-1.996-2z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-leaderboard_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrLeaderboard;
